
// footer.component.ts

import { Component } from '@angular/core';
import { APP_VERSION } from '../../core/constants/app-version';

@Component({
  selector: 'app-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  currentYear: number;
  appVersion = APP_VERSION;

  constructor() {
    this.currentYear = new Date().getFullYear();
  }

}
